<template>
  <div id="" class="">
    <h1>
      This is an app for you to store your personal notes and links from the
      internet
    </h1>
    Create your first dashboard here
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "",
  components: {},
};
</script>

<style lang="scss"></style>
